import React from "react";
import { MARQUEE_ITEMS } from "../data/mock";

const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="bg-[#1b2b4d] border-y border-white/5 py-6 overflow-hidden">
      <div className="marquee-track">
        {items.map((item, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-serif italic text-white/85 text-xl md:text-2xl px-8">
              {item}
            </span>
            <span className="text-[var(--gold)] text-lg">◆</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
